<template>
	<div>
		<el-select :value="value" :clearable="clearable" :size="size" :multiple="multiple" :placeholder="placeholder"
			:disabled="disabled" @change="change" filterable>
			<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
			</el-option>
		</el-select>
	</div>
</template>
<style scoped>
	.readonly {
		pointer-events: none;
	}

	.readonly>* {
		pointer-events: none;
	}

	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			flowid: {
				default: () => {
					return 0
				}
			},
			formid: {
				default: () => {
					return 0
				}
			},
			controlltype: {
				type: Number,
				default: () => {
					return 0
				}
			},
			componenttype: {
				type: Number,
				default: () => {
					return 0
				}
			},
			componentname: {
				default: () => {
					return 'form'
				}
			}
		},
		data() {
			return {
				staffid: [],
				ready: false,
				options: [],
				sourceData: [],
				activeName: 'modalStaff',
				store: {},
				fApi: {},
				modalShow: false,
				loading: false,
			}
		},
		created() {
			
		},
		watch: {
			controlltype(){
				this.list()
			}
		},
		computed: {

		},
		methods: {
			list() {
				
				let obj = {
					currentPage: -1
				}
				if (this.formid != 0) {
					obj.formid = this.formid
				}
				if (this.controlltype != 0) {
					obj.controlltype = this.controlltype
				}
				if (this.componenttype != 0) {
					obj.componenttype = this.componenttype
				}
				if (this.componentname) {
					obj.componentname = this.componentname
				}
	
				this.$api.formcontroll.list(obj).then((res) => {
					let options = []
					//console.log(this.formid,this.flowid,res.list,6666)
					res.list.forEach((item) => {
						if(item.flowid == this.flowid){
							options.push({
								value: item.id,
								label: item.name
							})
						}
					})
					this.options = options
					this.finish()
				})
			},
			init() {

			},
			show() {

			},
			hide() {
				this.loading = false
				this.back()
			},
			handleClick() {

			},
			submit() {
				let data = this.$refs.modalStaff.submitData()
				let value = data.length != 0 ? data[0].id : null
				if (this.formCreateInject) {
					let field = this.formCreateInject.field
					if (this.multiple) {
						this.formCreateInject.api.setValue(field, value)
					} else {
						this.formCreateInject.api.setValue(field, value)
					}
				} else {
					if (this.multiple) {
						this.$emit('modalsubmit', {
							data: value
						})
					} else {
						this.$emit('modalsubmit', {
							data: value
						})
					}
				}
				this.back()
				//console.log(data,this.formCreateInject)	
			},
			modal() {
				let arr = []
				arr.push(this.value)
				this.staffid = arr
				this.modalShow = true
			},
			back() {
				this.modalShow = false
			},
		},
		components: {

		}
	}
</script>
